// extracted by mini-css-extract-plugin
export default {"searchFormWrapper":"SearchForm_searchFormWrapper__EGsjL","form":"SearchForm_form__NGJ42","opened":"SearchForm_opened__FFqmN"};